import React from "react";
import { Row, Container, Col, Image } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";
import sampleImage from "../Images/kits.png";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>LORA-BASED COMMUNICATION SYSTEMS</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 We implement Low-Power Wide-Area Network (LPWAN) solutions using LoRa technology to enable secure and long-range wireless communication for IoT devices. Our LoRa-based systems are ideal for smart agriculture, asset tracking, environmental monitoring, and urban infrastructure. They provide cost-effective, energy-efficient communication over distances up to several kilometers, even in challenging environments.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-white">
      <Container>
        <Row className="align-items-center">
          {/* Image Column */}
          <Col md={6} className="mb-4 mb-md-0">
            <Image src={sampleImage} alt="Descriptive alt text" fluid rounded />
          </Col>

          {/* Content Column */}
          <Col md={6}>
            <h2>Empowering Smart Solutions</h2>
            <p>
              We design intelligent systems that leverage IoT, AI, and cloud technologies
              to drive digital transformation across industries. Our solutions are tailored
              to boost productivity, ensure sustainability, and deliver measurable outcomes.
            </p>
            <ul>
              <li>Custom IoT Integration</li>
              <li>Cloud-connected analytics</li>
              <li>Real-time monitoring</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
